import { render, staticRenderFns } from "./itemgroups.vue?vue&type=template&id=356c1f5d&scoped=true&"
import script from "./itemgroups.vue?vue&type=script&lang=js&"
export * from "./itemgroups.vue?vue&type=script&lang=js&"
import style0 from "./itemgroups.vue?vue&type=style&index=0&id=356c1f5d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "356c1f5d",
  null
  
)

export default component.exports